import React, { useEffect, useMemo, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Form, FormControl, InputGroup, Spinner } from "react-bootstrap";

import { isEmpty } from "lodash";
import { fourPlaceHolder, groupSlots } from "modules/utilities/utility";
import CardDiv from "modules/common/card-div/CardDiv";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Tooltip } from "antd";
import { useConsultDoctor } from "../actionables/store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import _ from "lodash";
import { useUpdateFeedBack } from "./store";

function LeadSLotBooking({
  caseId,
  filterSlotData,
  setFilterSlotData,
  selectedDate,
  setSelectedDate,
  selectedSlot,
  setSelectedSlot,
  sessionId,
  slotBooking = false,
  handleClose
}) {
  const { allSlotData, allSlotLoading, fetchSlotData, postSlotApiData, postSlotData } =
    useConsultDoctor();
  const { setToaster } = useToast();
  const { feedbackResponse } = useUpdateFeedBack();

  useEffect(()=>{
    if(!_.isEmpty(feedbackResponse && slotBooking && selectedSlot)){
      handleBookSlot();
    }
  },[feedbackResponse]);


  useEffect(() => {
    if (slotBooking) {
      setFilterSlotData(null);
      if (slotBooking) {
        fetchSlotData(caseId, sessionId, toast, true);
      }
    } else {
      setSelectedDate(null);
      setFilterSlotData(null);
      setSelectedSlot(null);
    }
  }, [slotBooking]);

  useEffect(() => {
    if (!isEmpty(allSlotData)) {
      const groupSlot = groupSlots(allSlotData);
      setFilterSlotData(groupSlot);
    }
  }, [allSlotData]);

  const handleDate = (date) => {
    setSelectedDate(date);
    setSelectedSlot(null);
  };

  const handleDoctorSlot = (slot) => {
    setSelectedSlot(slot);
  };

  const handleBookSlot = () => {
    const selectedSlotPayload = {
      case_id: caseId,
      slot_id: selectedSlot.id,
      slots: selectedSlot?.slots,
      order_related: false,
      is_rescheduling: true,
      session_id: sessionId,
      from_crm: true,
    };
    postSlotApiData(selectedSlotPayload, setToaster, handleClose);
  };

  return (
    <>
      <div>
        {slotBooking ? (allSlotLoading ? fourPlaceHolder() : null) : null}
        <div className="d-flex gap-2 flex-wrap justify-content-center mt-3">
          {filterSlotData &&
            Object.keys(filterSlotData)?.map((slotDate) => {
              return (
                <div
                  className="cursor-pointer"
                  onClick={() => handleDate(slotDate)}
                >
                  <CardDiv
                    title={
                      <div
                        className={
                          slotDate == selectedDate
                            ? "text-primary fw-bold"
                            : "fw-bold"
                        }
                      >
                        {moment(slotDate).format("ddd DD")}
                      </div>
                    }
                    component={
                      <div
                        className={
                          slotDate == selectedDate
                            ? "text-primary fw-bold"
                            : "fw-bold"
                        }
                      >
                        {slotDate}
                      </div>
                    }
                  />
                </div>
              );
            })}
        </div>
        <div
          className="d-flex gap-3 flex-wrap mt-5 scrollable-container"
          style={{ maxHeight: "50vh", overflowY: "scroll" }}
        >
          {selectedDate &&
            filterSlotData[selectedDate]?.map((timeSlot) => {
              return (
                <Button
                  style={{ width: "100px" }}
                  onClick={() => handleDoctorSlot(timeSlot)}
                  className={
                    timeSlot?.slots?.count === 0
                      ? " py-2 fs-1 bg-secondary text-white rounded-5 cursor-na disabled pointer-events-none text-center"
                      : selectedSlot?.slotTime == timeSlot?.slotTime
                      ? "py-2 fs-1 bg-success text-white rounded-5 cursor-pointer text-center"
                      : " py-2 fs-1 rounded-5  bg-white text-black border border-secondary cursor-pointer text-center"
                  }
                >
                  {moment(timeSlot?.slotTime).format("hh:mm A")}
                </Button>
              );
            })}
        </div>
      </div>
    </>
  );
}
export default LeadSLotBooking;
